// @ts-nocheck
import * as React from 'react';
import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useObservable } from '@ngneat/react-rxjs';
import { activeService$ } from '../../features/user/user_repository';
import { token$ } from '../../features/auth/auth_repository';
import { createDocumentFromCrawl } from '../../features/documents/documents_service';
import { IconContext } from 'react-icons';
import { CiCircleChevLeft } from 'react-icons/ci';
import { updateIsLoading } from '../../features/global_loader/global_loader_service';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from '../../ui_components/breadcrumbs/breadcrumbs';
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from '../../ui_components/form/form';
import { Input } from '../../ui_components/input/input';
import { Textarea } from '../../ui_components/textarea/textarea';
import { Button } from '../../ui_components/button/button';

const formSchema = z.object({
    documentUrl: z.string().nonempty('Url is required'),
});

export function AddDocumentCrawl() {
    const [token] = useObservable(token$);
    const [activeService] = useObservable(activeService$);
    let params = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        defaultValues: {
            documentUrl: '',
        },
    });

    async function onSubmit(values: z.infer<typeof formSchema>) {
        const { documentUrl } = values;

        updateIsLoading(true);
        await createDocumentFromCrawl(
            {
                serviceId: activeService.service_id,
                directoryId: params.directoryId,
                url: documentUrl,
            },
            token
        );
        updateIsLoading(false);

        return navigate(`/directories/${params.directoryId}`);
    }

    return (
        <article className="flex-1 rounded-xl md:min-h-min rounded-xl border bg-card text-card-foreground shadow p-6">
            <Breadcrumb>
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <Link to="/admin">Home</Link>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <Link to={`/directories/${params.directoryId}`}>
                            Directories
                        </Link>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbPage>Crawl document</BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>

            <header className="flex items-center justify-between mb-8 min-h-[40px]">
                <h2 className="font-semibold tracking-tight text-xl flex flex-col space-y-1.5">
                    Get from website address
                </h2>
            </header>

            <Form {...form}>
                <form
                    onSubmit={form.handleSubmit(onSubmit)}
                    className="space-y-6 max-w-3xl mx-auto"
                >
                    <FormField
                        control={form.control}
                        name="documentUrl"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Document url</FormLabel>
                                <FormControl>
                                    <Input {...field} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />

                    <Button type="submit">Crawl</Button>
                </form>
            </Form>
        </article>
    );
}
